import AlertBlue from "@/app/components/ui/Alerts/Blue";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { LatestEMRDetails } from "@/app_redux/reducers/slices/auth/customer_emr_slice";
import { fromUnixTime } from "date-fns";
import { FaStackOverflow } from "react-icons/fa6";

export type OverDraftEMRModalState = LatestEMRDetails & {
  /** Set when the prompt was raised from the Voice to EMR button, so Update
   *  opens the draft with recording already armed. */
  voice?: boolean;
};

const OverdraftEMRModal = () => {
  const { createdAt, emrId, status, voice } = useModalState("EMR_OVERDRAFT_MODAL") as OverDraftEMRModalState;

  const { setInvisible } = useModalActions("EMR_OVERDRAFT_MODAL");

  return (
    <ModalPrompt
      modalId="EMR_OVERDRAFT_MODAL"
      backdropBlur
      button={{
        primaryButtonText: "Update",
        primaryCallback: () => {
          window.open(
            `${"/app/customer/profile/create-emr"}?emr_id=${emrId}&emr_status=${status}${voice ? "&voice=1" : ""}`,
            "_blank",
          );
        },
        shouldHideOnClick: true,
        primaryButtonClassname:
          "rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
        secondaryButtonText: "Cancel",
        secondaryCallback: () => {
          setInvisible();
        },
      }}
      title={
        <div className="flex justify-start items-center gap-x-2">
          <span className="text-xl">
            <FaStackOverflow />
          </span>
          <span>Clear Your EMR Drafts</span>
        </div>
      }
      content={
        <div className="text-gray-600 text-sm">
          <p>
            You already have 1 EMR on draft for the same pet and customer. Please{" "}
            <span className="text-blue-600">update</span> the latest Draft EMR for the Pet & Customer or either{" "}
            <span className="text-red-500">delete</span> existing drafts.{" "}
          </p>
          <div className="mt-2">
            <AlertBlue title={`Latest Draft : ${fromUnixTime(createdAt)?.toDateString()}`}></AlertBlue>
          </div>
        </div>
      }
    />
  );
};

export default OverdraftEMRModal;
